import { Typography } from '@mui/material';
import React from 'react';
const Details: React.FC<any> = () => {
  return (
    <Typography
      variant="body1"
      gutterBottom
      sx={{ textAlign: 'center', color: 'rgba(0,0,0,0.6)', mt: 15, mb: 25, width: '100%' }}
    >
      Details content will come soon!
    </Typography>
  );
};
export default Details;
